

fc_AOS();

function fc_AOS() {
    AOS.init();
}

fc_SwiperSlider_CustomData();

function fc_SwiperSlider_CustomData() {
    const sliderSelector = ".swiper-container";
    const dataDefault = {};
    const eachSlider = document.querySelectorAll(sliderSelector);

    eachSlider.forEach((slider) => {
        const data = slider.getAttribute("data-slide");
        if (!data) return;

        const dataOptions = JSON.parse(data);
        slider.options = Object.assign({}, dataDefault, dataOptions);
        new Swiper(slider, slider.options);
    });
}


function fc_PlayMusic() {
    const buttons = document.querySelectorAll(".unmute-btn");
    const wrappers = document.querySelectorAll(".video-custom-wrapper");

    wrappers.forEach(wrapper => {
        const video = wrapper.querySelector("video");
        if (video) {
            video.muted = true;
            video.play().catch(() => {
            });
        }
    });

    buttons.forEach(button => {
        button.addEventListener("click", () => {
            const wrapper = button.closest(".video-custom-wrapper");
            const video = wrapper?.querySelector("video");

            if (!video) return;

            video.muted = !video.muted;

            if (video.paused) {
                video.play().catch(() => {
                });
            }

            button.classList.toggle("is-playing-sound", !video.muted);
        });
    });
}

document.addEventListener("DOMContentLoaded", fc_PlayMusic);
function fc_BackToTop(action, event) {
    const btn = document.querySelector('.js-back-to-top');

    if (action === 'init') {
        window.addEventListener('scroll', () => {
            btn?.classList.toggle('active', window.scrollY > 1000);
        });
    }

    if (action === 'scroll') {
        event?.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    fc_BackToTop('init');
});
setTimeout(function () {
    fc_ChangeVariable();
}, 500)

function fc_ChangeVariable() {
    const colorSwatches = document.querySelectorAll(".html_color_names");

    colorSwatches.forEach((swatch) => {
        const hoverImage = swatch.getAttribute("data-image-hover");
        if (hoverImage) {
            const img = new Image();
            img.src = hoverImage;
        }
    });

    colorSwatches.forEach((swatch) => {
        const card = swatch.closest(".product-variable");
        if (!card) return;

        const mainImageContainer = card.querySelector(".card-img-top");
        if (!mainImageContainer) return;

        const firstImage = mainImageContainer.querySelector("img");
        if (!firstImage) return;
        const originalSrc = firstImage.dataset.src || firstImage.src;

        swatch.addEventListener("mouseenter", () => {
            const hoverImage = swatch.getAttribute("data-image-hover");
            if (hoverImage && hoverImage !== originalSrc) {
                firstImage.src = hoverImage;
                firstImage.dataset.src = hoverImage;
                firstImage.classList.add("loaded");
                firstImage.removeAttribute("srcset");
            }
        });

        swatch.addEventListener("mouseleave", () => {

            firstImage.src = originalSrc;
            firstImage.dataset.src = originalSrc;
            firstImage.classList.add("loaded");

            firstImage.removeAttribute("srcset");
        });
    });
}

function fc_LazyLoad() {
    const lazyImages = document.querySelectorAll(".lazyload:not(.loaded)");
    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                img.src = img.dataset.src;
                img.onload = () => img.classList.add("loaded");
                obs.unobserve(img);
            }
        });
    });
    lazyImages.forEach(img => observer.observe(img));
}

document.addEventListener("DOMContentLoaded", () => {
    fc_LazyLoad();
});


fc_ThumbSwiper();

function fc_ThumbSwiper() {
    const sliderSelector = ".swiper-container-pd-thumb",
        dataDefault = {};
    const eachSlider = document.querySelectorAll(sliderSelector);

    eachSlider.forEach((slider) => {
        const data = slider.getAttribute("data-slide");
        const pd_sync_id = slider.getAttribute("data-swiper-v");
        if (data) {
            const dataOptions = JSON.parse(data);
            const thumbsOptions = dataOptions.thumb;
            let thumbsInit;
            let swiper;
            let thumbs;
            if (thumbsOptions) {
                const thumbImages = slider.querySelectorAll("img");
                let slides = "";
                thumbImages.forEach(function (img) {
                    slides +=
                        "\n<div class='swiper-slide'>\n<img class='img-fluid' src=".concat(
                            img.src + "&width=246",
                            " alt='image' loading='lazy'/>\n</div>\n"
                        );
                });
                thumbs = document.createElement("div");
                thumbs.setAttribute("class", "swiper js-thumb");
                thumbs.innerHTML = "<div class='swiper-wrapper'>".concat(
                    slides,
                    "</div>"
                );
                thumbs.insertAdjacentHTML(
                    "beforeend",
                    '<div class="cs-navigation"><div class="cs-swiper-button cs-swiper-button-prev"><span></span></div><div class="cs-swiper-button cs-swiper-button-next"><span></span></div></div>'
                );
                if (thumbsOptions.parent) {
                    const parent = document.querySelector(thumbsOptions.parent);
                    parent.parentNode.appendChild(thumbs);
                } else {
                    slider.parentNode.appendChild(thumbs);
                }
                thumbsOptions.options = Object.assign(
                    {
                        navigation: {
                            nextEl: thumbs.querySelector(".cs-swiper-button-next"),
                            prevEl: thumbs.querySelector(".cs-swiper-button-prev"),
                        },
                    },
                    thumbs,
                    thumbsOptions
                );
                thumbsInit = new window.Swiper(thumbs, thumbsOptions.options);
                slider.options = Object.assign(
                    {
                        thumbs: {
                            swiper: thumbsInit,
                        },
                    },
                    dataDefault,
                    dataOptions
                );
                swiper = new Swiper(slider, slider.options);
            } else {
                slider.options = Object.assign({}, dataDefault, dataOptions);
                swiper = new Swiper(slider, slider.options);
            }
            const syncIdIndex = window.localStorage.getItem(
                `pd_sync_${pd_sync_id}`
            );
            if (syncIdIndex != null) {
                swiper.slideTo(syncIdIndex, 0);
            }
            const height = document.querySelector(".style-vertical .swiper-horizontal");
            if (height && thumbs) {
                thumbs.style.height = height.offsetHeight + "px";
            }

        }
    });
}

fc_Parallax();

function fc_Parallax() {
    jarallax(document.querySelectorAll('.jarallax'), {
        imgSize: 'object-fit'
    });
}

fc_Compare();

function fc_Compare() {
    const viewers = document.querySelectorAll(".image-compare");
    const options = {
        smoothingAmount: 100,
        hoverStart: true
    };
    viewers.forEach((element) => {
        let view = new ImageCompare(element).mount();
    });
}

document.addEventListener('mousemove', fc_ParrallaxImages);

function fc_ParrallaxImages(e) {
    const movedX = (e.clientX * -0.3) / 8;
    const movedY = (e.clientY * -0.3) / 8;
    const elements = document.getElementsByClassName('js-parallaxed');

    for (let i = 0; i < elements.length; i++) {
        elements[i].style.transform = 'translate(' + movedX + 'px,' + movedY + 'px)';
    }
}

function handleClickOnDetails() {
    let detailsOpened = document.querySelectorAll(
        ".details-toggle details[open]"
    );

    for (const item of detailsOpened) {
        if (this != item) {
            item.removeAttribute("open");
        }
    }
}

fc_Details_toggle();

function fc_Details_toggle() {
    document.addEventListener('click', function (event) {
        const detailsElement = event.target.closest(".details-toggle details");
        if (detailsElement) {
            handleClickOnDetails.call(detailsElement);
        }
    });
}

fc_Hotspots();

function fc_Hotspots() {
    document.addEventListener('DOMContentLoaded', function () {
        const items = document.querySelectorAll('.item-hotspots');

        items.forEach(item => {
            const btn = item.querySelector('.btn-icon-plus');
            const content = item.querySelector('.content-hotspots');
            const closeModalBtn = content.querySelector('.btn-close-modal');

            btn.addEventListener('click', function (e) {
                e.stopPropagation();
                items.forEach(otherItem => {
                    if (otherItem !== item) {
                        otherItem.classList.remove('active');
                    }
                });
                const isActive = item.classList.toggle('active');
                if (isActive) {
                    document.body.classList.add('active-overlay');
                } else {
                    const anyItemActive = Array.from(items).some(item => item.classList.contains('active'));
                    if (!anyItemActive) {
                        document.body.classList.remove('active-overlay');
                    }
                }
            });

            content.addEventListener('click', function (e) {
                e.stopPropagation();
            });

            if (closeModalBtn) {
                closeModalBtn.addEventListener('click', function (e) {
                    e.stopPropagation();
                    item.classList.remove('active');
                    document.body.classList.remove('active-overlay');
                });
            }
        });

        document.addEventListener('click', function () {
            items.forEach(item => {
                item.classList.remove('active');
            });
            document.body.classList.remove('active-overlay');
        });
    });
}


function fc_Sticky() {
    const header = document.querySelector('.header_transparent');

    if (header) {
        window.addEventListener('scroll', () => {
            header.classList.toggle('active', window.scrollY > 80);
        });
    }
}

fc_Sticky();
function fc_Video() {
    let isProcessing = false;

    document.addEventListener('click', e => {
        const btn = e.target.closest('.btn-sound');
        if (!btn || isProcessing) return;

        isProcessing = true;

        const id = btn.dataset.player;
        const el = document.getElementById(id);
        if (!el) return;

        const video = el.querySelector?.('video');
        const iframe = el.tagName === 'IFRAME' ? el : null;
        const isMuted = btn.classList.contains('is-muted');

        document.querySelectorAll('.btn-sound').forEach(b => {
            const idplayer = document.getElementById(b.dataset.player);
            if (!idplayer) return;

            b.classList.add('is-muted');
            b.classList.remove('is-unmuted');

            const v2 = idplayer.querySelector?.('video');

            if (idplayer.tagName === 'IFRAME') {
                idplayer.contentWindow?.postMessage('{"event":"command","func":"mute"}', '*');
            } else if (v2) {
                v2.muted = true;
                v2.play().catch(()=>{});
            }
        });

        if (iframe) {
            iframe.contentWindow?.postMessage(JSON.stringify({
                event: "command",
                func: isMuted ? "unMute" : "mute"
            }), "*");
        }

        if (video) {
            video.muted = !isMuted;
            video.play().catch(()=>{});
        }

        btn.classList.toggle('is-muted', !isMuted);
        btn.classList.toggle('is-unmuted', isMuted);

        setTimeout(() => {
            isProcessing = false;
        }, 300);
    });
}
fc_Video();

function fc_Animation_Content(){
    const track = document.querySelector('.announcement-track');
    const items = document.querySelectorAll('.announcement-item');

    let current = 0;
    const itemHeight = 40;

    setInterval(() => {
        current++;

        if (current >= items.length) {
            current = 0;
        }

        track.style.transform = `translateY(-${current * itemHeight}px)`;
    }, 3000);
}
fc_Animation_Content();
if (Shopify.designMode) {
    document.addEventListener("shopify:section:load", () => {
        fc_Sticky();
        fc_AOS();
        fc_SwiperSlider_CustomData();
        fc_Details_toggle();
        fc_Hotspots();
        fc_Parallax();
        fc_LazyLoad();
        fc_Compare();
        fc_Video();

    });
    document.addEventListener("shopify:section:select", () => {
        fc_SwiperSlider_CustomData();
        fc_AOS();
        fc_LazyLoad();
    });
    document.addEventListener("shopify:section:deselect", () => {
    });
    document.addEventListener("shopify:block:select", () => {
    });
    document.addEventListener("shopify:block:deselect", () => {
    });
    document.addEventListener("shopify:inspector:activate", () => {
    });
    document.addEventListener("shopify:inspector:deactivate", () => {
    });
}
